<template>
 <SearchComponent  />
</template>

<script setup lang="ts">


import SearchComponent from "../components/search-form/SearchComponent.vue";
</script>
